import { render, staticRenderFns } from "./update_patient.vue?vue&type=template&id=fe3b14aa&"
import script from "./update_patient.vue?vue&type=script&lang=js&"
export * from "./update_patient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports